import React from "react";
import PropTypes from "prop-types";
import { kebabCase } from "lodash";
import { Link } from "gatsby";
export default function DisplayContentHeader(props) {
  const {
    showTags = "true",
    tags = [],
    ulClass = "taglist",
    divClass = "taglist-inner",
  } = props;

  return (
    <React.Fragment>
      {showTags && tags && tags.length ? (
        <div>{tagList(tags, ulClass, divClass)}</div>
      ) : null}
    </React.Fragment>
  );
}

DisplayContentHeader.propTypes = {
  showTags: PropTypes.bool,
  tags: PropTypes.array,
  ulClass: PropTypes.string,
  divClass: PropTypes.string,
};

function tagLink(tag) {
  return "/tags/" + kebabCase(tag);
}
function tagList(group, ulClass, divClass) {
  return (
    <div className={divClass}>
      <ul className={ulClass}>
        <li>Tagged:</li>
        {group.map((tag) => (
          <li key={tag}>
            <Link to={tagLink(tag)} title={tag}>
              {tag}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
